import React from "react";
import VendorModel from "../models/vendor_model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";

interface TableProps {
    vendors: VendorModel[];
    onRowClicked: (vendorId: number) => void;
}

export default class VendorItemDashboardTableWidget extends React.Component<TableProps> {
    render(): React.ReactNode {
        return (
            <div className="overflow-x-auto">
                <table className="table-fixed w-full text-center border-collapse">
                    <thead>
                        <tr className="bg-gray-300">
                            <th className="p-2 border border-gray-400 w-1/12">
                                Nama Vendor
                            </th>
                            <th className="p-2 border border-gray-400 w-1/12">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.vendors.map((vendor) => (
                            <tr
                                className="bg-white hover:bg-gray-100 transition"
                                key={vendor.id}
                            >
                                <td className="p-2 border border-gray-400">
                                    {vendor.name}
                                </td>
                                <td className="p-2 border border-gray-400">
                                    <button
                                        className="px-3 py-1 rounded-md bg-purple-500 hover:bg-purple-700 text-white"
                                        onClick={() =>
                                            this.props.onRowClicked(vendor.id)
                                        }
                                    >
                                        Lihat Item
                                        <FontAwesomeIcon
                                            className="mx-3"
                                            icon={faPencil}
                                        />
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }
}
